import { useNavigate } from 'react-router-dom';

import { InviteRequestForm } from '../components/InviteRequestForm';

export const InviteRequest = () => {
  const navigate = useNavigate();

  return <InviteRequestForm onSuccess={() => {}} />;
};
